import { apiApproveContract } from "services/ContractService";
import {
  clearSignupContractApprovals,
  readSignupContractApprovals,
  saveSignupContractApprovals,
} from "utils/contractApprovalsStorage";

const processSignupContractApprovals = async () => {
  const pendingIds = readSignupContractApprovals();
  if (!pendingIds.length) {
    return { approved: [], failed: [] };
  }

  const approved = [];
  const failed = [];

  for (const contractversionid of pendingIds) {
    try {
      await apiApproveContract(contractversionid);
      approved.push(contractversionid);
    } catch {
      failed.push(contractversionid);
    }
  }

  if (failed.length) {
    saveSignupContractApprovals(failed);
  } else {
    clearSignupContractApprovals();
  }

  return { approved, failed };
};

export default processSignupContractApprovals;
